import React from "react";
import styled from "@emotion/styled";
import dimensions from "styles/dimensions";
import { RichText } from "prismic-reactjs";
import PropTypes from "prop-types";

const HeroContainer = styled("section")`
    position: relative;
    zoom: 1;
    display: block;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;

    @media(min-width: ${dimensions.minwidthTablet}px) {
    }
`

const HeroText = styled("div")`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  
  padding: 48px 12.5% 24px;

  @media(min-width: ${dimensions.minwidthTablet}px) {
    padding-right: 25%;
    padding-bottom: 48px;
  }

  @media(min-width: ${dimensions.minwidthDesktop}px) {
    position: absolute;
    top: 3vh;
    left: 0;
    z-index: 5;
    background: rgba(255,255,255,.95);
    width: 43.75%;
    padding: 2.125% 3.125% 0 6.25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: auto;
  }

  div.tagline {
    color: #303030;
    margin-bottom: 4px;
    font-size: calc(.625rem + .375vw - 1.2px);
    line-height: calc(1rem + 1vw - 3.2px);
    letter-spacing: calc(.125rem + .25vw - .8px);
    text-transform: uppercase;
    font-weight: 500;
  }

  h1 {
    margin: .5em auto;
    padding: 0;

    color: #303030;
    font-size: calc(1.25rem + 1.875vw - 6px);
    line-height: calc(1.5rem + 2vw - 6.4px);
    font-weight: 700;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      /* height: 0; */
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
      height: auto;
    }
  }
`

const HeroImageWrapper = styled("div")`
  margin: 0;
  padding: 0;
  display: flex;
  position: relative;

  img {
    width: 100%;
    display: block;
    max-width: 100%;
  }

  div.heroImage {
    position: relative;
    /* padding-bottom: 56.25%; */
    width: 87.5%;

    @media(min-width: ${dimensions.minwidthDesktop}px){
      margin-left: 20%;
      width: 67.5%;
      padding: 0;
      /* height: 80vh; */
    }
  }

  div.socialWrapper {
    margin: 0;
    padding: 0;
    display: flex;
    width: 12.5%;
    /* align-items: center; */
    justify-content: center;

    @media(min-width: ${dimensions.minwidthDesktop}px){
      position: absolute;
      right: 0;
      top: 0;
      margin-top: 18.75%;
    }

    div.socialLinks {
      margin: 0;
      padding: 0;
      writing-mode: vertical-lr;
      margin-left: auto;
      margin-right: auto;

      @media(min-width: ${dimensions.minwidthDesktop}px){
        min-height: 262px;
      }

      a {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 30px;
        font-size: 18px;
        color: #303030;
        text-decoration: none;
      }

      a:not(:last-of-type) {
        margin-bottom: 16px;
      }
    }
  }
`

const Hero = ({ headline, copy, image  }) => (
<HeroContainer>
  <HeroImageWrapper
    data-sal="slide-left"
    data-sal-duration="500"
    data-sal-delay="150"
    data-sal-easing="ease-out"
  >
    
  <div className="heroImage">
    <img src={image.url} alt={image.alt} />
  </div>
  </HeroImageWrapper>
  
  <HeroText
    data-sal="slide-right"
    data-sal-duration="500"
    data-sal-delay="150"
    data-sal-easing="ease-out"
  >
    <div className="tagline">{RichText.asText(copy)}</div>
    {RichText.render(headline)}
  </HeroText>
  
</HeroContainer>
)

export default Hero;

Hero.propTypes = {
    headline: PropTypes.array.isRequired,
    copy: PropTypes.array.isRequired,
    image: PropTypes.array.isRequired,
    cta_text: PropTypes.array.isRequired,
    cta_target: PropTypes.array.isRequired,
};